module.exports = __webpack_public_path__ + "static/media/Statua_041.445f096a.jpg";